import styled from 'styled-components';

// Covers the whole screen: nothing else can be clicked while the orders are being sent
export const Backdrop = styled.div`
    position: fixed;
    inset: 0;
    z-index: 1400;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.35);
`;

export const Card = styled.div`
    width: 340px;
    max-width: calc(100vw - 32px);
    box-sizing: border-box;
    padding: 24px 24px 20px;
    border-radius: 12px;
    background: white;
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    text-align: center;
    color: #1f2a33;
`;

export const Title = styled.div`
    font-size: 17px;
    font-weight: 500;
`;

export const Text = styled.div`
    font-size: 14px;
    color: #424242;
`;

export const Bar = styled.div`
    width: 100%;
`;
